import styles from '../../../pages/LeadCapture/LeadCaptureMonitor/LeadCaptureMonitor.module.css'
import ExhibitorLeadsSnapshot from './ExhibitorLeadsSnapshot'
const LeadsSnapshot = ({ index, leadsSnapshot }) => {
    const changeDateTimeFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };
        return date.toLocaleDateString('en-us', options);
    }
    return (
        <>
            <tr className={styles.trLeadsSnapshot} key={index}>
                <td className={styles.tdLeadsSnapshot}> {leadsSnapshot.client}</td>
                <td className={styles.tdLeadsSnapshot}> {leadsSnapshot.eventName}</td>
                <td className={styles.tdLeadsSnapshot}> {leadsSnapshot.refNumber}</td>
                <td className={styles.tdLeadsSnapshot}> {changeDateTimeFormat(leadsSnapshot.startDate)}</td>
                <td className={styles.tdLeadsSnapshot}> {leadsSnapshot.totalLeads}</td>
                <td className={styles.tdLeadsSnapshot}>
                    <table className={styles.tableLeadsSnapshots}>
                        <thead>
                            <tr className={styles.trLeadsSnapshot}>
                                <th className={styles.thLeadsSnapshots}>
                                    Ref Number
                                </th>
                                <th className={styles.thLeadsSnapshots}>
                                    Name
                                </th>
                                <th className={styles.thLeadsSnapshots}>
                                    Organization
                                </th>
                                <th className={styles.thLeadsSnapshots}>
                                    Count
                                </th>
                            </tr>
                        </thead>
                        <tbody key={index}>
                            {leadsSnapshot.exhibitors.map((item, index) => (
                                <ExhibitorLeadsSnapshot
                                    index={index}
                                    exhibitorLeadsSnapshot={item}
                                >
                                </ExhibitorLeadsSnapshot>
                            ))}
                        </tbody>

                    </table>
                    <ul className={styles.trLeadsSnapshot} key={index}>
                       
                    </ul>
                </td>
                
            </tr>
        </>
    );
}

export default LeadsSnapshot;
